import { atom } from 'jotai';

/** Controls visibility of the in-app feedback dialog. */
export const feedbackDialogOpenAtom = atom(false);
